import Buffer from 'buffer';

import { render } from 'preact';

import 'moment';
import 'moment/locale/ru';
import 'moment/locale/en-gb';

import './assets/global-styles.scss';
import './assets/global-mui-overrides.scss';

window.Buffer = Buffer.Buffer;
global.Buffer = Buffer.Buffer;

function initApp() {
  import('./App')
    // eslint-disable-next-line react/jsx-pascal-case
    .then((Module) => { render(<Module.default />, document.body); });
}

if (process.env.PREACT_APP_ENV === 'development') {
  initApp();
} else {
  initApp();
}
